import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";



const ChartTemp = ({ data, startTime, endTime }) => {
  const { t } = useTranslation();
  const [chartData, setChartData] = useState([]);

  const toLocalTime = (utcTime, day) => {
    var date = new Date(utcTime + "+00:00");
    let hour = date.getHours();
    if (hour < 15) {
      day = 0;
    }
    date.setDate(date.getDate() - day);
    return (new Date(date)).getTime() - ((new Date(date)).getTimezoneOffset() * 60 * 1000)
  }

  useEffect(() => {
    if (data.length) {
      // const dataFilter = data.filter(item => {
      //   var date = new Date(item.dateTime + "+00:00");
      //   let hour = date.getHours();
      //   if (hour < 18 && hour > 9) {
      //     return null;
      //   }
      //   return item;
      // })
      const parsedData = data.map((item) => ({
        x: item.dateTime,
        y: item.value,
      }));
      setChartData(parsedData);
    }
  }, [data]);

  const options = {
    title: {
      text: "",
    },
    chart: {
      type: "line",
      height: 250,
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 100,
    },
    xAxis: {
      type: "datetime",
      tickWidth: 0,
      tickInterval: 30 * 60 * 1000, // 30 minutes in milliseconds
      gridLineWidth: 2,
      gridLineDashStyle: "dot",
      labels: {
        enabled: true,
      },
      lineColor: "black",
      lineWidth: 5,
      min: startTime,
      max: endTime,
      margin: 10,
    },
    yAxis: [
      {
        title: {
          text: t("graph.tempePosi.temperature"),
          align: "high",
          rotation: 0,
          y: 20,
          style: {
            fontSize: 16,
            color: "#000000",
            fontWeight: "bold",
          },
        },
        labels: {
          formatter: function () {
            return this.value + "℃";
          },
        },
        tickInterval: 10,
        min: 10,
        max: 50,
        lineWidth: 2,
        showFirstLabel: false,
        showLastLabel: false,
      },
    ],

    series: [
      {
        name: t("graph.tempePosi.temperature"),
        data: chartData,
        color: "#004AAD",
        showInLegend: false,
        zIndex: 2,
      },
    ],
    legend: {
      layout: "vertical",
      align: "left",
      verticalAlign: "bottom",
      y: 50,
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          //   enabled: true,
        },
      },
      line: {
        marker: {
          enabled: false,
        },
      },
    },
  };
  return (
    <div className="chart-term-container">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default ChartTemp;
